module.exports = __webpack_public_path__ + "img/slider1torta.76e8b2d9.webp";